import { BeaconErrorType } from '@airgap/beacon-types';
import { BeaconError } from './BeaconError';
/**
 * @category Error
 */
export class TransactionInvalidBeaconError extends BeaconError {
    data;
    name = 'TransactionInvalidBeaconError';
    title = 'Transaction Invalid';
    get fullDescription() {
        return { description: this.description, data: JSON.stringify(this.data, undefined, 2) };
    }
    constructor(data) {
        super(BeaconErrorType.TRANSACTION_INVALID_ERROR, `The transaction is invalid and the node did not accept it.`);
        this.data = data;
        this.data = data;
    }
}
//# sourceMappingURL=TransactionInvalidBeaconError.js.map